//
// Generated by @himenon/openapi-typescript-code-generator v0.27.4
//
// OpenApi : 3.0.0
//
//
import {
  Params$AdminBillingDocumentController_getCreditNoteCapabilities,
  Response$AdminBillingDocumentController_getCreditNoteCapabilities$Status$200,
  ResponseContentType$AdminBillingDocumentController_getCreditNoteCapabilities,
} from '@api-client/generated/client';
import { QueryOptions, useApiClient } from '@hooks/useApiClient';

export const useAdminBillingDocumentController_getCreditNoteCapabilities =
  (options: {
    params: Params$AdminBillingDocumentController_getCreditNoteCapabilities['parameter'];
    config?: QueryOptions<
      Response$AdminBillingDocumentController_getCreditNoteCapabilities$Status$200[ResponseContentType$AdminBillingDocumentController_getCreditNoteCapabilities]
    >;
  }) =>
    useApiClient<
      Params$AdminBillingDocumentController_getCreditNoteCapabilities,
      Response$AdminBillingDocumentController_getCreditNoteCapabilities$Status$200[ResponseContentType$AdminBillingDocumentController_getCreditNoteCapabilities]
    >({
      method: 'AdminBillingDocumentController_getCreditNoteCapabilities',
      params: { parameter: options.params },
      config: options.config,
    });
